import { useRef } from 'react';
import Link from 'next/link';
import { useToggle } from '@/hooks/useToggle';
import Menu, { MenuItem } from '@/components/Menu';
import { ArrowDownIcon } from '@/icons';
import { PLATFORMS } from '../constants';
import { classes } from './utils';

export default function PlatformSelector() {
  const menuToggleRef = useRef<HTMLDivElement>(null);
  const [isMenuOpen, toggleMenu] = useToggle(false);

  return (
    <>
      <div ref={menuToggleRef}>
        <div className={classes.wrapper} onClick={() => toggleMenu()}>
          <span className={classes.label}>Insights</span>
          <ArrowDownIcon className={classes.arrowIcon} />
        </div>
      </div>
      <Menu
        anchorTo={menuToggleRef.current}
        open={isMenuOpen}
        onClose={() => toggleMenu()}>
        <Link href={PLATFORMS.CRM}>
          <MenuItem label="CRM" />
        </Link>
        <Link href={PLATFORMS.UNISON}>
          <MenuItem label="Unison" />
        </Link>
        {/*<Link href={PLATFORMS.PERSPECTIVE}>*/}
        {/*  <MenuItem label="Perspective" />*/}
        {/*</Link>*/}
      </Menu>
    </>
  );
}
